import { onlineT } from "../../../typings/online";
import { paymentT } from "../../../typings/payment";
import { DialogFormController } from "../../../shared/dialog/dialog-form.controller";
import { Enums, Events } from "../../../thor.enums";
import { setPaymentsDeposit } from "../../../utils/payment";

export class CreateLinkPaymentDialogController extends DialogFormController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$rootScope",
        "$translate",
        "linkPaymentService",
        "localeNumber",
        "onlinePriceService",
        "paymentService",
        "toaster"
    ];

    // binded
    public containerId: number;
    public contractId: number;
    public items: onlineT.Item[];
    public lastBidder: onlineT.LastBidder;
    public linkPaymentType: paymentT.thor.LinkPaymentStateType;
    public saleCurrency: Enums.Currency;
    public saleDepositAmount: number;
    public salePaymentDeposit: paymentT.Payment[];

    public linkPaymentPost: paymentT.thor.LinkPaymentPost;
    public linkPaymentTypeLabel: string;

    public depositStateLabel: string;
    public paymentsDepositAmount: number;

    private $t;

    constructor(
        private $log: ng.ILogService,
        $mdDialog: ng.material.IDialogService,
        $mdMedia: ng.material.IMedia,
        private $rootScope: ng.IRootScopeService,
        $translate: ng.translate.ITranslateService,
        private linkPaymentService: any,
        private localeNumber,
        protected onlinePriceService,
        public paymentService,
        toaster: any
    ) {
        super($mdDialog, $mdMedia, toaster);

        this.$t = $translate.instant;
    }

    public $onInit() {
        const { user_id: userId } = this.lastBidder;

        this.partial = "create";
        this.title = this.$t(this.isSlip() ? "lien_de_paiement_du_bordereau" : "lien_de_paiement_de_l_expedition");

        this.linkPaymentTypeLabel = this.$t(this.isSlip() ? "amount_for_lot.item" : "amount_for_lot.delivery", [
            this.items.length,
            this.localeNumber.getCurrencySymbol(this.saleCurrency)
        ]);

        if (!userId) {
            return this._onError({ error: "Missing data" });
        }

        const itemsIds = this.items.map(user => user.id);
        const paymentsDeposit = setPaymentsDeposit(
            userId,
            this.items.reduce((acc, i) => [...acc, ...(i.payment) || []], []),
            this.salePaymentDeposit
        );

        this.depositStateLabel = this.paymentService.getDepositStateLabel(paymentsDeposit);
        this.paymentsDepositAmount = this.localeNumber.sumNbrs(paymentsDeposit.map(p => Number(p.amount)));

        this.linkPaymentPost = {
            user_id: userId,
            contract_id: this.contractId,
            items_ids: itemsIds,
            sale_id: this.containerId,
            amount: this.isSlip() ? this.calculateFinalSoldPriceTotal() : null,
            nature: paymentT.PaymentNature.INTEGRAL_PAYMENT,
            type: this.linkPaymentType,
            organization_comment: ""
        };
    }

    public onSubmit() {
        this.preventSubmit = true;

        this.linkPaymentService
            .create(this.containerId, this.linkPaymentPost)
            .then(() => {
                this.$rootScope.$emit(Events.OnlineSalePaymentsUpdated);

                this.$mdDialog.hide();

                this.toaster.show(
                    this.$t(
                        this.isSlip()
                            ? "le_lien_de_paiement_3ds_du_bordereau_a_ete_envoye_a_l_adjudicataire"
                            : "le_lien_de_paiement_3ds_de_l_expedition_a_ete_envoye_a_l_adjudicataire"
                    )
                );
            })
            .catch((error: any) => this._onError(error));
    }

    private calculateFinalSoldPriceTotal(): number {
        const depositTotal = this.paymentsDepositAmount || 0;
        const finalSoldPriceTotal = this.localeNumber.sumNbrs(this.items.map(item => item.finalSoldPrice));
        return this.localeNumber.roundNbr(finalSoldPriceTotal - depositTotal);
    }

    private isSlip(): boolean {
        return this.linkPaymentType === paymentT.thor.LinkPaymentStateType.ITEM;
    }

    private _onError(error: any = {}) {
        this.$log.error("Unable to create link payment : ", error);

        this.$mdDialog.hide();

        this.toaster.show(this.$t("create_link_payment_alert.error"), true);
    }
}
